export default __webpack_public_path__ + "static/media/Bindings of Dark Terror.3e50ce3f.jpg";